import React from 'react';
import {Layout, TabsContainer} from '../../components';
import ElevatorServicesTab from './ElevatorServicesTab';
import EscalatorServicesTab from './EscalatorServicesTab';

const HEADERS = ['Elevator Services', 'Escalator Services'];
const ElevatorTab = <ElevatorServicesTab />;
const EscalatorTab = <EscalatorServicesTab />;
const TAB_CONTENTS = [ElevatorTab, EscalatorTab];

const Services = () => {
  return (
    <Layout>
      <TabsContainer tabHeaders={HEADERS} tabContents={TAB_CONTENTS} />
    </Layout>
  );
};

export default Services;
